import { Component, OnInit, Injector } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SecondPageEditBase } from 'vnpost-shared';
import { CategoryService } from '../../services/category.service';

@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.css'],
})
export class EditCategoryComponent
  extends SecondPageEditBase
  implements OnInit
{
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];
  isDisable: any;

  constructor(
    protected _categoryService: CategoryService,
    protected _injector: Injector
  ) {
    super(_categoryService, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl('', [Validators.required]),
      name: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl('', [Validators.required]),
    });
  }

  ngOnInit() {}

  onShowPopup(model: any) {
    this.isDisable = model.isDisable;
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (model.id > 0) {
      this._categoryService.getCategoryDetail(model.id).then(
        (rs) => {
          this.itemDetail = rs.data;
        },
        (error) => {
          if (error?.error?.message) 
            this._notifierService.showError(error?.error?.message);
          else this._notifierService.showWarning(
            this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
          );
        }
      );
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this.onUpdate();
  }

  onUpdate() {
    this._categoryService.update(this.itemDetail.id, this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      }
    );
  }
}
